export enum HistoryTab {
  Trades = 'Trades',
  Orders = 'Orders',
  Funding = 'Funding',
  Deposits = 'Deposits',
  Transfers = 'Transfers',
  Liquidations = 'Liquidations',
}
